export const EXPEDIENTE_TYPE_MINER = 0
export const EXPEDIENTE_TYPE_BATCH = 1

export interface ExpedienteSearchItemResponse {
  id: string
  code: string
  /** 0 = Miner (provider expediente), 1 = Batch (shipment expediente). */
  type: number
  /** RUC of the provider (Miner) or the shipment supplier (Batch). May be null
   *  on legacy batch records that pre-date the supplier link. */
  companyRuc: string | null
  companyLegalName: string | null
  status: number // 0 Draft, 1 Active, 2 Revoked
  approvedAt: string | null
  itemCount: number
  /** Datos del lote; sólo en expedientes Batch. */
  batch?: ExpedienteBatchSummary | null
}

export interface ExpedienteBatchSummary {
  batchCode: string
  shipmentState: number
  mineralTypeName: string | null
  mineralWeight: string | null
  measurementUnitName: string | null
  miningRightName: string | null
  miningRightCode: string | null
  collectionCenterName: string | null
  vehiclePlate: string | null
  driverName: string | null
  dispatchedAt: string
  receivedAt: string | null
  weighedAt: string | null
  sampledAt: string | null
  labCompletedAt: string | null
  reconciledAt: string | null
  settledAt: string | null
  /** Ya tiene el Acta de Trazabilidad: el lote está cerrado. */
  isSealed: boolean
}

export interface ExpedienteItemFileResponse {
  fileAttachmentId: string
  originalFileName: string
  contentType: string
  fileSize: number
  sha256: string | null
  folioCount: number
}

export interface ExpedienteItemResponse {
  id: string
  order: string
  itemType: number
  itemTypeName: string
  title: string
  description: string | null
  occurredAt: string
  registeredAt: string
  registeredByUserId: string
  registeredByUserName: string | null
  parentItemId: string | null
  contentDigest: string
  chainHash: string
  primaryFile: ExpedienteItemFileResponse | null
  childCount: number
  depth: number
  /** Folios propios del ítem (páginas del documento, o 1 para un registro
   *  digital; 0 para una carpeta/ancla que solo agrupa subitems). */
  folioCount: number
  /** Folios del grupo: propios + todos los descendientes. */
  groupFolioCount: number
  /** For pointer items (today: BatchExpedienteLink), the code of the
   *  expediente this item links to. Use it to lazy-load the linked
   *  expediente's items inline. Null for non-link items. */
  linkedExpedienteCode: string | null
}

/** ItemType discriminator constants (from MineTrace.Shared.Enums.ExpedienteItemType).
 *  Only listing the ones the frontend branches on. */
export const EXPEDIENTE_ITEM_TYPE_BATCH_LINK = 120

export interface ExpedienteDetailResponse {
  id: string
  code: string
  status: number
  statusName: string
  companyRuc: string
  companyLegalName: string
  cuidCode: string | null
  approvedAt: string | null
  revokedAt: string | null
  chainHead: string | null
  /** Total de ítems del expediente (todos, no solo la página). */
  itemCount: number
  /** Total de folios (hojas) del expediente completo. */
  totalFolios: number
  /** Cantidad de grupos de nivel superior (raíces). */
  topLevelCount: number
  page: number
  pageSize: number
  /** true si quedan más grupos de nivel superior por traer. */
  hasMore: boolean
  /** Ítems de la página: raíces de la página + todos sus descendientes. */
  items: ExpedienteItemResponse[]
}
